import '@daypicker/react/style.css'
import { CheckoutView } from './CheckoutView'
import type { HireBookingProps } from './types'
import { useCheckoutController } from './useCheckoutController'

export function HireBooking(props: HireBookingProps) {
    const checkout = useCheckoutController(props)
    return <CheckoutView checkout={checkout} />
}
